import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/**
 * WordPress dependencies
 */
import { Icon } from '@wordpress/icons';
export var StyledIcon = /*#__PURE__*/_styled(Icon, {
  target: "etxm6pv0",
  label: "StyledIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "i8uvf3",
  styles: "width:1.4em;height:1.4em;margin:-0.2em 0.1em 0;vertical-align:middle;fill:currentColor;"
} : {
  name: "i8uvf3",
  styles: "width:1.4em;height:1.4em;margin:-0.2em 0.1em 0;vertical-align:middle;fill:currentColor;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkB3b3JkcHJlc3MvY29tcG9uZW50cy9zcmMvZXh0ZXJuYWwtbGluay9zdHlsZXMvZXh0ZXJuYWwtbGluay1zdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVXdDIiwiZmlsZSI6IkB3b3JkcHJlc3MvY29tcG9uZW50cy9zcmMvZXh0ZXJuYWwtbGluay9zdHlsZXMvZXh0ZXJuYWwtbGluay1zdHlsZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEV4dGVybmFsIGRlcGVuZGVuY2llc1xuICovXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbi8qKlxuICogV29yZFByZXNzIGRlcGVuZGVuY2llc1xuICovXG5pbXBvcnQgeyBJY29uIH0gZnJvbSAnQHdvcmRwcmVzcy9pY29ucyc7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRJY29uID0gc3R5bGVkKCBJY29uIClgXG5cdHdpZHRoOiAxLjRlbTtcblx0aGVpZ2h0OiAxLjRlbTtcblx0bWFyZ2luOiAtMC4yZW0gMC4xZW0gMDtcblx0dmVydGljYWwtYWxpZ246IG1pZGRsZTtcblx0ZmlsbDogY3VycmVudENvbG9yO1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
//# sourceMappingURL=external-link-styles.js.map